import React from "react";
import { Bar, Chart } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);

const SummaryBar = (props) => {
  const {data, options = null} = props;

  const defaultOptions = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  };

  return (
    <div style={{minWidth: "320px", margin: "auto", minHeight: "325px", width: "90%", maxWidth: "700px"}}>
      <Bar data={data} options={options === null ? defaultOptions : options} />
    </div>
  )
};

export {SummaryBar};